import React, { Component } from "react";
import "./stylesheets/userManagement.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackSiteid,
  getBackUserDetails,
  submitUser,
  UserAdd,
  getBackDateSite,
  getBackUserEdit,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import {
  Button,
  Dropdown,
  Offcanvas,
  Form,
  FloatingLabel,
  Table,
} from "react-bootstrap";

export default class UserManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showData: false,
      scroll: false,
      backdrop: false,
      TotalListCount: 0,
      name: "Job",
      EligibleForINC: true,
      EligibleForTLA: false,
      EligibleForSWA: false,
      EligibleForSPA: false,
      placement: "end",
      userdetails: [],
      siteId: 0,
      selectedSite: "Site Id",
      listSiteId: "",
      employeeIdhd: "",
      StartDateFromDp: new Date(),
      StartDateFromDpe: "",
      endDateFromDp: "",
      StartDateToDp: new Date(),
      StartDateToDpe: "",
      endDateToDp: "",
      StartDateFromTr: new Date(),
      StartDateFromTra: "",
      endDateToTr: "",
      StartDateFromTe: new Date(),
      StartDateFromTer: "",
      endDateToTe: "",
      StartDateFromAddr: new Date(),
      StartDateFromAdd: "",
      endDateToAdd: "",
      EmployeeIdAdd: "",
      DesignationAdd: "",
      NameAdd: "",
      DesignationDp: "",
      RemarksDp: "",
      DesignationTr: "",
      RemarksTr: "",
      RemarksTe: "",
      NameEd: "",
      DesignationEd: "",
      RemarksEd: "",
      siteAdd: "",
      userDetailsMain: [],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var sendData = {
      userid: userId,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendData);
      const datarespsites = await responsesites;
      var siteIdArr = [];
      var siteIdDesArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }

      const responseAllsites = await getBackDateSite(sendData);
      const datarespAllsites = await responseAllsites;

      if (siteIdArr.length > 0) {
        for (var i = 0; i < datarespAllsites.length; i++) {
          var siteIdDes = {};
          // if(datarespAllsites[i].SiteID !==siteIdArr[0].key){
          siteIdDes.key = datarespAllsites[i].SiteID;
          siteIdDes.value = datarespAllsites[i].SiteName;
          siteIdDes.MinDate = datarespAllsites[i].MinDate;
          siteIdDesArr.push(siteIdDes);
          // }
        }
        this.setState({
          DesignationDp: siteIdDesArr[0].key + "/" + siteIdDesArr[0].MinDate,
          DesignationTr: siteIdDesArr[0].key,
          StartDateFromAddr: new Date(siteIdDesArr[0].MinDate),
          endDateFromAdd: new Date(),
        });
      }

      const selectedTenant = localStorage.getItem("selected_tenant");
      const selectedTenantData = JSON.parse(selectedTenant);

      if (selectedTenantData.Tenant === "Thisco") {
        var siteType = [{ key: "Terminate", value: "Terminate" }];
      } else {
        var siteType = [
          {
            key: "Depute",
            value: "Depute",
          },
          { key: "Transfer", value: "Transfer" },
          { key: "Terminate", value: "Terminate" },
        ];
      }
      var userData = [
        {
          siteName: siteIdDesArr,
          siteType: siteType,
          StartDateFromEd: new Date(),
          endDateFromEd: "",
          StartDateToEd: new Date(),
          endDateToEd: "",
        },
      ];

      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        siteId: siteIdArr[0].key,
        siteAdd: siteIdArr[0].key,
        siteIdDesArr: siteIdDesArr,
        userDetailsMain: userData,
      });
    };
    fetchsiteid();
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      this.setState({
        Permission: filteredData[0].PermissionCode,
      });
    } else {
      this.setState({
        Permission: "",
      });
    }
  }

  handleInputFetch = (event) => {
    var loadingData = "No data Found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    const siteId = this.state.siteId;
    var sendData = {
      site_id: siteId,
    };
    const fetchUserdetails = async () => {
      const responseUser = await getBackUserDetails(sendData);
      const datarespUser = await responseUser;
      if (datarespUser.length > 0) {
        this.setState({
          loading: false,
          loadingData: loadingData,
        });
      } else {
        loadingData = "No data found";
      }
      this.setState({
        userdetails: datarespUser,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchUserdetails();
  };

  handleDataChange = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleDataChangeAdd = (event) => {
    var valueData = event.target.value;
    var finalData = valueData.split("/");
    var mainValue = finalData[0];
    var mainDate = finalData[1];
    event.preventDefault();
    this.setState({
      DesignationDp: valueData,
      StartDateFromAddr: new Date(mainDate),
      endDateFromAdd: new Date(),
    });
  };

  handleDataChangeUserManage = (i) => (event) => {
    var valueData = event.target.value;
    var finalData = valueData.split("/");
    var mainValue = finalData[0];
    var mainDate = finalData[1];
    var DateData = mainDate;
    var posId = i - 1;
    var preData = this.state.userDetailsMain[posId];
    if (preData !== "" && preData !== null && preData !== undefined) {
      var preDate = this.state.userDetailsMain[posId].AllocationToDate;
      if (preDate !== "" && preDate !== null && preDate !== undefined) {
        var FromDate = preDate;
        var ToDate = mainDate;
        var dateCom = Moment(ToDate).isAfter(FromDate);
        if (dateCom === true) {
          DateData = mainDate;
        } else {
          var currentDate = Moment(preDate, "DD-MM-YYYY").add(1, "days");
          DateData = currentDate;
        }
      } else {
        DateData = mainDate;
      }
    } else {
      if (
        this.state.joinDataData !== "" &&
        this.state.joinDataData !== null &&
        this.state.joinDataData !== undefined
      ) {
        var FromDate = this.state.joinDataData;
        var ToDate = mainDate;
        var dateCom = Moment(ToDate).isAfter(FromDate);

        if (dateCom === true) {
          DateData = mainDate;
        } else {
          var currentDate = Moment(FromDate, "YYYY-MM-DD").add(1, "days");
          DateData = currentDate;
        }
      } else {
        DateData = mainDate;
      }
    }
    event.preventDefault();
    this.setState((state, props) => {
      state.userDetailsMain[i].SiteID = valueData;
      state.userDetailsMain[i].MinFromDate = new Date(DateData);
      return {
        userDetailsMain: state.userDetailsMain,
      };
    });
    this.setState({
      showAddBtn: false,
      TotalListCount: "-1",
    });
  };

  handleChangeDp = (selectedDate) => {
    this.setState({
      StartDateFromDpe: selectedDate,
    });
  };

  handleChangeToDp = (selectedDate) => {
    this.setState({
      StartDateToDpe: selectedDate,
    });
  };

  handleChangeTr = (selectedDate) => {
    this.setState({
      StartDateFromTra: selectedDate,
    });
  };

  handleChangeTe = (selectedDate) => {
    this.setState({
      StartDateFromTer: selectedDate,
    });
  };
  handleChangeAdd = (selectedDate) => {
    this.setState({
      StartDateFromAdd: selectedDate,
    });
  };

  handleClose = (event) => {
    this.setState({ showData: false });
  };

  handleChangeCheck = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handleChangeCheckINC = (event) => {
    this.setState({ [event.target.name]: true });
  };
  handleShow = (event, row) => {
    var employeeIdhd = "";
    var UserId = "";
    var nameEd = "";
    var LoginId = "";
    var joinData = "";
    var cusData = event;
    var JobMaxDate = new Date();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    if (event !== "Add User") {
      cusData = "";
      const fetchUserEdit = async () => {
        var sendData = {
          userId: row.UserId,
        };
        var sendDataMain = {
          userid: row.UserId,
        };
        const responseAllsites = await getBackDateSite(sendDataMain);
        const datarespAllsites = await responseAllsites;
        var siteIdDesArr = [];
        for (var i = 0; i < datarespAllsites.length; i++) {
          var siteIdDes = {};
          // if(datarespAllsites[i].SiteID !==siteIdArr[0].key){
          siteIdDes.key = datarespAllsites[i].SiteID;
          siteIdDes.value = datarespAllsites[i].SiteName;
          siteIdDes.MinDate = datarespAllsites[i].MinDate;
          siteIdDesArr.push(siteIdDes);
          // }
        }

        const selectedTenant = localStorage.getItem("selected_tenant");
        const selectedTenantData = JSON.parse(selectedTenant);

        const responseUser = await getBackUserEdit(sendData);
        const datarespUser = await responseUser;
        if (datarespUser !== "" && datarespUser !== null) {
          var SiteAllocations = datarespUser.SiteAllocations;
          if (SiteAllocations.length > 0) {
            var userData = [];
            for (let index = 0; index < SiteAllocations.length; index++) {
              var element = {};
              const filteredDataCheck = siteIdDesArr.filter((obj) => {
                return obj.key === SiteAllocations[index].SiteID;
              });
              element.TechnicianSiteID =
                SiteAllocations[index].TechnicianSiteID;
              element.SiteID =
                SiteAllocations[index].SiteID +
                "/" +
                filteredDataCheck[0].MinDate;
              element.AllocationFromDate =
                SiteAllocations[index].AllocationFromDate === null
                  ? ""
                  : new Date(SiteAllocations[index].AllocationFromDate);
              element.AllocationToDate =
                SiteAllocations[index].AllocationToDate === null
                  ? ""
                  : new Date(SiteAllocations[index].AllocationToDate);
              element.AllocationType = SiteAllocations[index].AllocationType;
              element.ModSiteYN =
                SiteAllocations[index].ModSiteYN === false ? true : false;
              element.ModTypeYN =
                SiteAllocations[index].ModTypeYN === false ? true : false;
              element.ModFromDateYN =
                SiteAllocations[index].ModFromDateYN === false ? true : false;
              element.MinFromDate =
                SiteAllocations[index].MinFromDate === null
                  ? ""
                  : new Date(SiteAllocations[index].MinFromDate);
              element.ModToDateYN =
                SiteAllocations[index].ModToDateYN === false ? true : false;
              element.MinToDate =
                SiteAllocations[index].MinToDate === null
                  ? ""
                  : new Date(SiteAllocations[index].MinToDate);
              element.DeleteYN = SiteAllocations[index].DeleteYN;
              if (element.AllocationType === "Return") {
                if (selectedTenantData.Tenant === "Thisco") {
                  var siteType = [{ key: "Terminate", value: "Terminate" }];
                } else {
                  var siteType = [
                    {
                      key: "Depute",
                      value: "Depute",
                    },
                    { key: "Transfer", value: "Transfer" },
                    { key: "Terminate", value: "Terminate" },
                    { key: "Return", value: "Return" },
                  ];
                }
              } else {
                if (selectedTenantData.Tenant === "Thisco") {
                  var siteType = [{ key: "Terminate", value: "Terminate" }];
                } else {
                  var siteType = [
                    {
                      key: "Depute",
                      value: "Depute",
                    },
                    { key: "Transfer", value: "Transfer" },
                    { key: "Terminate", value: "Terminate" },
                  ];
                }
              }
              element.siteType = siteType;
              element.siteName = siteIdDesArr;
              element.IsDeleted = false;
              element.MaxFromDate = "";
              element.MaxToDate = "";
              userData.push(element);
            }
          } else {
            var userData = [];
          }
          employeeIdhd = row.LoginId + ", " + row.DisplayName;
          joinData =
            "Joined " +
            Moment(datarespUser.JoinDate).format("DD-MMM-YYYY") +
            ", " +
            datarespUser.SiteName;
          this.setState({
            userDetailsMain: userData,
            employeeIdhd: employeeIdhd,
            joinData: joinData,
            joinDataData: datarespUser.JoinDate,
            EligibleForTLAMan: datarespUser.EligibleForTLA,
            EligibleForSWAMan: datarespUser.EligibleForSWA,
            EligibleForSPAMan: datarespUser.EligibleForSPA,
            EligibleForINCMan: datarespUser.EligibleForINC,
            TotalListCount: datarespUser.SiteAllocations.length - 1,
            showAddBtn: true,
          });
        }
        // else{
        //   var siteType = [{
        //     key:'Depute',
        //    value:'Depute',
        //   },{key:'Transfer',
        //    value:'Transfer',
        //   },{key:'Terminate',
        //    value:'Terminate',
        //   }]
        //   var userData = [{
        //     siteName: siteIdDesArr,
        //     siteType: siteType,
        //     StartDateFromEd: new Date(),
        //     endDateFromEd: '',
        //     StartDateToEd: new Date(),
        //     endDateToEd: "",
        //   }];
        //   this.setState({
        //     userDetailsMain:userData,
        //   });
        // }
      };
      fetchUserEdit();

      UserId = row.UserId;
      nameEd = row.DisplayName;
      LoginId = row.LoginId;
      JobMaxDate = new Date(row.JobMaxDate);
    }
    this.setState({
      showData: true,
      customer: event,
      customerData: cusData,
      NameEd: nameEd,
      EmployeeIdEd: employeeIdhd,
      employeeIdhd: employeeIdhd,
      userId: UserId,
      LoginId: LoginId,
      joinData: joinData,
    });
  };

  handleDropdownSite = (key, event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var sendDataMain = {
      userid: userId,
    };
    const fetchsiteidAll = async () => {
      var siteIdDesArr = [];
      const responseAllsites = await getBackDateSite(sendDataMain);
      const datarespAllsites = await responseAllsites;
      for (var i = 0; i < datarespAllsites.length; i++) {
        var siteIdDes = {};
        if (datarespAllsites[i].SiteID !== parseInt(key)) {
          siteIdDes.key = datarespAllsites[i].SiteID;
          siteIdDes.value = datarespAllsites[i].SiteName;
          siteIdDes.MinDate = datarespAllsites[i].MinDate;
          siteIdDesArr.push(siteIdDes);
        }
      }
      this.setState({
        DesignationDp: siteIdDesArr[0].key + "/" + siteIdDesArr[0].MinDate,
        DesignationTr: siteIdDesArr[0].key,
        StartDateFromAddr: new Date(siteIdDesArr[0].MinDate),
        endDateFromAdd: new Date(),
        siteIdDesArr: siteIdDesArr,
      });
    };
    fetchsiteidAll();
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      userdetails: [],
      showData: false,
    });
  };

  handleSubmitManage = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var userDetailsMain = this.state.userDetailsMain;
    var mainUserData = [];
    var ErrorLog = [];

    for (let indexTE = 0; indexTE < userDetailsMain.length; indexTE++) {
      var errorObj = {};
      var FromDate = userDetailsMain[indexTE].AllocationFromDate;
      var ToDate = userDetailsMain[indexTE].AllocationToDate;
      var dateCom = Moment(ToDate).isAfter(FromDate);
      if (userDetailsMain[indexTE].AllocationType === "Depute") {
        dateCom = ToDate >= FromDate;
      }
      if (
        userDetailsMain[indexTE].AllocationType === "Depute" &&
        userDetailsMain[indexTE].IsDeleted === false
      ) {
        if (dateCom !== true) {
          errorObj.error = true;
          this.setState((state, props) => {
            state.userDetailsMain[indexTE].ErrorDate = true;
            return {
              userDetailsMain: state.userDetailsMain,
            };
          });
        } else {
          errorObj.error = false;
          this.setState((state, props) => {
            state.userDetailsMain[indexTE].ErrorDate = false;
            return {
              userDetailsMain: state.userDetailsMain,
            };
          });
        }
      } else {
        errorObj.error = false;
        this.setState((state, props) => {
          state.userDetailsMain[indexTE].ErrorDate = false;
          return {
            userDetailsMain: state.userDetailsMain,
          };
        });
      }

      ErrorLog.push(errorObj);
    }
    const filteredDataCheck = ErrorLog.filter((obj) => {
      return obj.error === true;
    });
    if (filteredDataCheck.length > 0) {
    } else {
      // if(userDetailsMain.length >0){
      for (let index = 0; index < userDetailsMain.length; index++) {
        const element = {};
        var siteData = userDetailsMain[index].SiteID;
        var finalData = siteData.split("/");
        var mainValue = finalData[0];
        var mainDate = finalData[1];
        element.TechnicianSiteId = userDetailsMain[index].TechnicianSiteID;
        element.SiteId = mainValue === "" ? 0 : parseInt(mainValue);
        element.AllocationFromDate =
          userDetailsMain[index].AllocationFromDate === ""
            ? "9999-12-31"
            : Moment(userDetailsMain[index].AllocationFromDate).format(
                "YYYY-MM-DD"
              );
        if (userDetailsMain[index].AllocationToDate !== "") {
          element.AllocationToDate =
            userDetailsMain[index].AllocationToDate === ""
              ? ""
              : Moment(userDetailsMain[index].AllocationToDate).format(
                  "YYYY-MM-DD"
                );
        } else {
          // var toData = Moment(new Date(), "DD-MM-YYYY").add(4, 'month');
          element.AllocationToDate = "9999-12-31";
        }
        element.AllocationType =
          userDetailsMain[index].AllocationType === ""
            ? "Terminate"
            : userDetailsMain[index].AllocationType;
        element.IsDeleted = userDetailsMain[index].IsDeleted;
        const filteredDataCount = userDetailsMain.filter((obj) => {
          return obj.IsDeleted === false;
        });
        var userDetailsMainData = filteredDataCount.length - 1;
        if (userDetailsMain[index].IsDeleted === false) {
          if (userDetailsMainData === index) {
            element.RowIndex = 1;
          } else {
            element.RowIndex = 0;
          }
        } else {
          element.RowIndex = 0;
        }

        mainUserData.push(element);
      }
      var submitData = {
        UserId: this.state.userId,
        LoginId: this.state.LoginId,
        DisplayName: this.state.NameEd,
        ApplicationCode: "Splice",
        EligibleForTLA: this.state.EligibleForTLAMan,
        EligibleForSWA: this.state.EligibleForSWAMan,
        EligibleForSPA: this.state.EligibleForSPAMan,
        EligibleForINC: this.state.EligibleForINCMan,
        SiteAllocations: mainUserData,
        ModifiedBy: userId,
      };

      const UserSubmit = async () => {
        const responsesites = await submitUser(submitData, userId);
        if (responsesites === 200) {
          this.handleInputFetch();
          this.setState({ showData: false });
        }
      };
      var msg = "You want to submit this !";
      Swal.fire({
        title: "Are you sure?",
        text: msg,
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          UserSubmit();
        }
      });
      // }
    }
  };

  handleSubmitAdd = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var siteData = this.state.DesignationDp;
    var finalData = siteData.split("/");
    var mainValue = finalData[0];
    var mainDate = finalData[1];
    var submitData = {
      LoginId: this.state.EmployeeIdAdd,
      DisplayName: this.state.NameAdd,
      ApplicationCode: "Splice",
      SiteId: parseInt(mainValue),
      AllocationFromDate: Moment(this.state.StartDateFromAdd).format(
        "YYYY-MM-DD"
      ),
      UserRoleName: "Technician",
      ModifiedBy: userId,
      EligibleForTLA: this.state.EligibleForTLA,
      EligibleForSWA: this.state.EligibleForSWA,
      EligibleForSPA: this.state.EligibleForSPA,
      EligibleForINC: this.state.EligibleForINC,
    };

    const UserAddData = async () => {
      const responsesites = await UserAdd(submitData);
      this.handleInputFetch();
      this.setState({
        showData: false,
        EmployeeIdAdd: "",
        NameAdd: "",
        siteAdd: "",
        StartDateFromAdd: "",
        EligibleForTLA: false,
        EligibleForSWA: false,
        EligibleForSPA: false,
        EligibleForINC: true,
      });
    };
    UserAddData();
  };

  handleDataAddDetails = (event) => {
    event.preventDefault();
    this.setState({
      showAddBtn: false,
      TotalListCount: "-1",
    });
    var sendDataMain = {
      userid: this.state.userId,
    };
    const fetchsiteid = async () => {
      var siteIdDesArr = [];
      const selectedTenant = localStorage.getItem("selected_tenant");
      const selectedTenantData = JSON.parse(selectedTenant);
      const responseAllsites = await getBackDateSite(sendDataMain);
      const datarespAllsites = await responseAllsites;
      for (var i = 0; i < datarespAllsites.length; i++) {
        var siteIdDes = {};
        siteIdDes.key = datarespAllsites[i].SiteID;
        siteIdDes.value = datarespAllsites[i].SiteName;
        siteIdDes.MinDate = datarespAllsites[i].MinDate;
        siteIdDesArr.push(siteIdDes);
      }
      if (selectedTenantData.Tenant === "Thisco") {
        var siteType = [{ key: "Terminate", value: "Terminate" }];
      } else {
        var siteType = [
          {
            key: "Depute",
            value: "Depute",
          },
          { key: "Transfer", value: "Transfer" },
          { key: "Terminate", value: "Terminate" },
        ];
      }
      if (this.state.Permission === "VALIDATE_JOB") {
        siteType = [
          {
            key: "Depute",
            value: "Depute",
          },
        ];
      }

      var element = {};
      element.TechnicianSiteID = 0;
      element.SiteID = "";
      element.AllocationFromDate = "";
      element.AllocationToDate = "";
      element.AllocationType = "";
      element.ModSiteYN = false;
      element.ModTypeYN = false;
      element.ModFromDateYN = false;
      element.MinFromDate = "";
      element.ModToDateYN = false;
      element.MinToDate = "";
      element.DeleteYN = true;
      element.siteType = siteType;
      element.siteName = siteIdDesArr;
      element.IsDeleted = false;
      element.MaxFromDate = "";
      element.MaxToDate = "";
      this.setState(
        (prevState) => {
          var userDetailsMainData = this.state.userDetailsMain;
          var userData = [];
          for (let index = 0; index < userDetailsMainData.length; index++) {
            var element = {};
            const filteredDataCheck = siteIdDesArr.filter((obj) => {
              return obj.key === userDetailsMainData[index].SiteID;
            });
            // console.log('filteredDataCheck',filteredDataCheck);
            // console.log('userDetailsMainData[index].SiteID',userDetailsMainData[index].SiteID);
            // return false;
            element.TechnicianSiteID =
              userDetailsMainData[index].TechnicianSiteID;
            element.SiteID = userDetailsMainData[index].SiteID;
            element.AllocationFromDate =
              userDetailsMainData[index].AllocationFromDate;
            element.AllocationToDate =
              userDetailsMainData[index].AllocationToDate;
            element.AllocationType = userDetailsMainData[index].AllocationType;
            element.ModSiteYN = true;
            element.ModTypeYN = true;
            element.ModFromDateYN = true;
            element.MinFromDate = userDetailsMainData[index].MinFromDate;
            element.ModToDateYN = true;
            element.MinToDate = userDetailsMainData[index].MinToDate;
            element.DeleteYN = userDetailsMainData[index].DeleteYN;

            if (element.AllocationType === "Return") {
              if (selectedTenantData.Tenant === "Thisco") {
                var siteType = [{ key: "Terminate", value: "Terminate" }];
              } else {
                var siteType = [
                  {
                    key: "Depute",
                    value: "Depute",
                  },
                  { key: "Transfer", value: "Transfer" },
                  { key: "Terminate", value: "Terminate" },
                  { key: "Return", value: "Return" },
                ];
              }
            } else {
              if (selectedTenantData.Tenant === "Thisco") {
                var siteType = [{ key: "Terminate", value: "Terminate" }];
              } else {
                var siteType = [
                  {
                    key: "Depute",
                    value: "Depute",
                  },
                  { key: "Transfer", value: "Transfer" },
                  { key: "Terminate", value: "Terminate" },
                ];
              }
            }
            element.siteType = siteType;
            element.siteName = siteIdDesArr;
            element.IsDeleted = false;
            element.MaxFromDate = "";
            element.MaxToDate = "";
            userData.push(element);
          }
          return { userDetailsMain: userData };
        },
        () => {
          // this.setState(prevState => {
          //   return {TotalListCount : prevState.userDetailsMain.length}
          // });
          this.setState((prevState) => ({
            userDetailsMain: [...prevState.userDetailsMain, element],
          }));
        }
      );
    };
    fetchsiteid();
  };

  handleDataChangeUser = (i) => (event) => {
    event.preventDefault();
    var name = event.target.name;
    this.setState((state, props) => {
      state.userDetailsMain[i][name] = event.target.value;
      return {
        userDetailsMain: state.userDetailsMain,
      };
    });
  };

  handleDataChangeUserType = (i) => (event) => {
    event.preventDefault();
    var mainData = true;
    var value = event.target.value;
    if (value === "Depute") {
      mainData = false;
    }
    this.setState((state, props) => {
      state.userDetailsMain[i].AllocationType = event.target.value;
      state.userDetailsMain[i].ModToDateYN = mainData;
      return {
        userDetailsMain: state.userDetailsMain,
      };
    });
    this.setState({
      showAddBtn: false,
      TotalListCount: "-1",
    });
  };

  handleDataRemoveDetails = (i) => (event) => {
    event.preventDefault();

    this.setState(
      (state, props) => {
        state.userDetailsMain[i].IsDeleted = true;
        return {
          userDetailsMain: state.userDetailsMain,
        };
      },
      () => {
        var userDetailsMainData = this.state.userDetailsMain;
        var minusData = 0;
        for (let index = 0; index < userDetailsMainData.length; index++) {
          if (userDetailsMainData[index].IsDeleted === false) {
            minusData = index;
          }
        }
        this.setState({
          // TotalListCount : minusData
          showAddBtn: false,
          TotalListCount: "-1",
        });
      }
    );

    // this.setState(prevState => {
    //   return {TotalListCount : prevState.userDetailsMain.length - 1}
    // });
    // this.setState({userDetailsMain: this.state.userDetailsMain.filter(function(userDe,i) {
    //   if(i === event && userDe.FamilyDataID !== 0){
    //     deletefamilydata(userDe.FamilyDataID);
    //   }
    //   return i !== event
    // })});
  };

  handleDataChangeFromDate = (event, date) => {
    this.setState((state, props) => {
      state.userDetailsMain[event].AllocationFromDate = date;
      return {
        userDetailsMain: state.userDetailsMain,
      };
    });
    this.setState({
      showAddBtn: false,
      TotalListCount: "-1",
    });
  };

  handleDataChangeToDate = (event, date) => {
    this.setState((state, props) => {
      state.userDetailsMain[event].ErrorDate = false;
      state.userDetailsMain[event].AllocationToDate = date;
      return {
        userDetailsMain: state.userDetailsMain,
      };
    });
    this.setState({
      showAddBtn: false,
      TotalListCount: "-1",
    });
  };

  render() {
    const addUserLogo = require("../../../assets/images/add_user.png");
    const transferLogo = require("../../../assets/images/transfer.png");
    const terminationLogo = require("../../../assets/images/termination.png");
    const deputeLogo = require("../../../assets/images/depute.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");

    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);

    // const editUserLogo = require('../../../assets/images/edit_user.png');
    var listSiteId = this.state.listSiteId;
    const columns = [
      {
        dataField: "LoginId",
        text: "Employee Id",
        classes: "cursor",
        events:
          selectedTenantData.Tenant === "Thisco" &&
          permissionsreadData[0].PermissionCode === "VALIDATE_JOB"
            ? {}
            : {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                  this.handleShow("Manage User", row);
                },
              },
      },
      {
        dataField: "DisplayName",
        text: "Name",
      },
      {
        dataField: "Designation",
        text: "Designation",
      },
      {
        dataField: "Eligibility",
        text: "Allowance Eligibility",
      },
      {
        dataField: "AllocationFromDate",
        text: "Allocation From Date",
        formatter: (cellContent, row) => {
          return Moment(row.AllocationFromDate).format("DD-MMM-YYYY");
        },
      },
      {
        dataField: "Remarks",
        text: "Remarks",
      },
      // {
      //   dataField: 'Action',
      //   text: 'Action',
      //   classes: 'actionbtn',
      //   isDummyField: true,
      //   editable: false,
      //   formatter: (cellContent, row) => {
      //       return (
      //         <span>
      //         <span className='saveBtnUs'>
      //           <img src={deputeLogo}
      //                        alt="logo" className="logo-user" title='Depute User' onClick={() => {this.handleShow('Deputation',row)}}/>
      //             </span>
      //           <span className='saveBtnUs'>
      //             <img src={transferLogo}
      //                         alt="logo" className="logo-user" title='Transfer User' onClick={() => {this.handleShow('Transfer',row)}}/>
      //           </span>
      //           <span className='saveBtnUs'></span>
      //           <span className='saveBtnUs'>
      //           <img src={terminationLogo}
      //                       alt="logo" className="logo-user" title='Terminate User' onClick={() => {this.handleShow('Terminate',row)}}/>
      //         </span>

      //           </span>
      //       );
      //   },
      // }
    ];
    var products = this.state.userdetails;
    var userDetailsMain = this.state.userDetailsMain;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-user">
            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
          </div>
          <div className="submiteditbtnuser">
            {this.state.Permission === "AUTHORIZE_JOB" ? (
              <img
                src={addUserLogo}
                alt="logo"
                className="logo-add-user"
                title="Add User"
                onClick={() => {
                  this.handleShow("Add User");
                }}
              />
            ) : (
              <span className="logo-add-data"></span>
            )}
          </div>
        </div>
        <div className="table-container-user">
          <BootstrapTable
            classes="tabledata-user"
            keyField="JobID"
            id="tabledata"
            data={products}
            columns={columns}
            noDataIndication="No data found"
          />
        </div>
        <Offcanvas
          className="useroff"
          show={this.state.showData}
          scroll={this.state.scroll}
          name={this.state.name}
          backdrop={this.state.backdrop}
          placement={this.state.placement}
          responsive="sm"
          onHide={this.handleClose}
        >
          <Offcanvas.Header className="popup_header" closeButton>
            <Offcanvas.Title className="header_title">
              <span className="title_contant">
                {this.state.customerData + this.state.employeeIdhd}
              </span>
              <br />
              <span className="font_size_title">{this.state.joinData}</span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container">
              <div className="rowUser rowUserData">
                <div className="col-md-12">
                  {this.state.customer === "Add User" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleSubmitAdd}
                    >
                      <div className="rowUser">
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Employee Id *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="EmployeeIdAdd"
                              onChange={this.handleDataChange}
                              placeholder="Employee Id"
                              className="edit_job form__field"
                              value={this.state.EmployeeIdAdd}
                            />
                          </FloatingLabel>
                        </div>
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Name *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="NameAdd"
                              onChange={this.handleDataChange}
                              placeholder="Name"
                              className="edit_job form__field"
                              value={this.state.NameAdd}
                            />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForINC}
                            name="EligibleForINC"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForINC}
                            label="Incentive"
                          />
                        </div>
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForTLA}
                            name="EligibleForTLA"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForTLA}
                            label="TLA"
                          />
                        </div>
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForSWA}
                            name="EligibleForSWA"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForSWA}
                            label="SWA"
                          />
                        </div>
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForSPA}
                            name="EligibleForSPA"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForSPA}
                            label="SPA"
                          />
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive className="userTableAdd">
                            <thead>
                              <th>Site</th>
                              <th>Type</th>
                              <th>From Date</th>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <Form.Select
                                    aria-label="Floating label select example"
                                    name="DesignationDp"
                                    onChange={this.handleDataChangeAdd}
                                    className="edit_job form__field_select_table dateAsealign"
                                    value={this.state.DesignationDp}
                                  >
                                    {this.state.siteIdDesArr !== ""
                                      ? this.state.siteIdDesArr.map(
                                          (item, indexdata) => {
                                            return (
                                              <option
                                                key={indexdata}
                                                value={
                                                  item.key + "/" + item.MinDate
                                                }
                                              >
                                                {item.value}
                                              </option>
                                            );
                                          }
                                        )
                                      : ""}
                                  </Form.Select>
                                </td>
                                <td>
                                  <Form.Select
                                    aria-label="Floating label select example"
                                    name="DesignationDp"
                                    onChange={this.handleDataChange}
                                    className="edit_job form__field_select_table dateAsealign"
                                    value={this.state.DesignationDp}
                                  >
                                    <option value="Join">Join</option>
                                  </Form.Select>
                                </td>
                                <td>
                                  <DatePicker
                                    onChange={this.handleChangeAdd}
                                    selected={this.state.StartDateFromAdd}
                                    dateFormat="dd-MMM-yyyy"
                                    minDate={this.state.StartDateFromAddr}
                                    maxDate={this.state.endDateFromAdd}
                                    className="form-control-data border-remove dateAsealign"
                                    required
                                    placeholderText="From Date *"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      {/* <div className="rowUser">  */}
                      {/* <div className="col-md-6 form-group input-user">
                            <FloatingLabel controlId="floatingInputGrid" className="" label="Designation *">
                                  <Form.Control type="text" required name="DesignationAdd" onChange={this.handleDataChange} placeholder="Designation" className="edit_job form__field"  value={this.state.DesignationAdd} />
                              </FloatingLabel>
                          </div> */}
                      {/* <div className="col-md-6 form-group input-user dateAse">
                              <DatePicker
                                    onChange={this.handleChangeAdd}
                                    selected={this.state.StartDateFromAdd}
                                    dateFormat="dd-MM-yyyy"
                                    minDate={this.state.StartDateFromAddr}
                                    maxDate={this.state.endDateFromAdd}
                                    className="form-control"
                                    required
                                    placeholderText="From Date *"
                                />
                          </div> */}
                      {/* <div className="col-md-6 form-group input-user">
                            <FloatingLabel controlId="floatingSelect" label="Site *">
                              <Form.Select aria-label="Floating label select example" className="edit_job form__field_select" name="siteAdd"  onChange={this.handleDataChange} value={this.state.siteAdd}>
                                {listSiteId !== ''?
                                    listSiteId.map((item, indexdata) => {
                                    return (
                                      <option key={indexdata} value={item.key}>{item.value}</option>
                                    );
                                  })
                                  : ''}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                        </div> */}

                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="submit"
                          onClick={(event) =>
                            this.setState({ submitvalue: "90" })
                          }
                          className="btnval btn btn-success font_size"
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                  {this.state.customer === "Manage User" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleSubmitManage}
                    >
                      <div className="rowUser">
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForINCMan}
                            disabled={
                              this.state.Permission !== "AUTHORIZE_JOB" ||
                              selectedTenantData.Tenant === "Thisco"
                            }
                            name="EligibleForINCMan"
                            onChange={this.handleChangeCheckINC}
                            value={this.state.EligibleForINCMan}
                            label="Incentive"
                          />
                        </div>
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForTLAMan}
                            disabled={
                              this.state.Permission !== "AUTHORIZE_JOB" ||
                              selectedTenantData.Tenant === "Thisco"
                            }
                            name="EligibleForTLAMan"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForTLAMan}
                            label="TLA"
                          />
                        </div>
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForSWAMan}
                            disabled={
                              this.state.Permission !== "AUTHORIZE_JOB" ||
                              selectedTenantData.Tenant === "Thisco"
                            }
                            name="EligibleForSWAMan"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForSWAMan}
                            label="SWA"
                          />
                        </div>
                        <div className="col-md-3 form-group input-data">
                          <Form.Check
                            type="checkbox"
                            className="edit_job_edit form__field font_size"
                            checked={this.state.EligibleForSPAMan}
                            disabled={
                              this.state.Permission !== "AUTHORIZE_JOB" ||
                              selectedTenantData.Tenant === "Thisco"
                            }
                            name="EligibleForSPAMan"
                            onChange={this.handleChangeCheck}
                            value={this.state.EligibleForSPAMan}
                            label="SPA"
                          />
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive className="userTableAdd">
                            <thead>
                              <th className="userTableSite">Site</th>
                              <th className="userTableType">Type</th>
                              <th>From Date</th>
                              <th>To Date</th>
                              <th>
                                {this.state.showAddBtn === true ? (
                                  <span
                                    className="saveBtnUsPl cursor"
                                    onClick={this.handleDataAddDetails}
                                  >
                                    <FaPlusCircle />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </th>
                            </thead>
                            <tbody>
                              {userDetailsMain.length > 0 ? (
                                userDetailsMain.map((iteamTd, indexedTd) => {
                                  return iteamTd.IsDeleted === false ? (
                                    <tr key={indexedTd}>
                                      <td>
                                        <Form.Select
                                          aria-label="Floating label select example"
                                          name="SiteID"
                                          required={true}
                                          defaultValue={iteamTd.SiteID}
                                          onChange={this.handleDataChangeUserManage(
                                            indexedTd
                                          )}
                                          className="edit_job form__field_select_table dateAsealign"
                                          value={iteamTd.SiteID}
                                          disabled={iteamTd.ModSiteYN}
                                        >
                                          <option value="">Select Site</option>
                                          {iteamTd.siteName !== ""
                                            ? iteamTd.siteName.map(
                                                (item, indexdata) => {
                                                  return (
                                                    <option
                                                      key={indexdata}
                                                      value={
                                                        item.key +
                                                        "/" +
                                                        item.MinDate
                                                      }
                                                    >
                                                      {item.value}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ""}
                                        </Form.Select>
                                      </td>
                                      <td>
                                        <Form.Select
                                          aria-label="Floating label select example"
                                          name="AllocationType"
                                          required={true}
                                          defaultValue={iteamTd.AllocationType}
                                          onChange={this.handleDataChangeUserType(
                                            indexedTd
                                          )}
                                          className="edit_job form__field_select_table dateAsealign"
                                          value={iteamTd.AllocationType}
                                          disabled={iteamTd.ModTypeYN}
                                        >
                                          <option value="">Select Type</option>
                                          {iteamTd.siteType !== ""
                                            ? iteamTd.siteType.map(
                                                (itemT, indexdataT) => {
                                                  return this.state
                                                    .Permission ===
                                                    "VALIDATE_JOB" &&
                                                    iteamTd.ModTypeYN ===
                                                      false ? (
                                                    <option
                                                      key={indexdataT}
                                                      disabled={
                                                        itemT.value === "Depute"
                                                          ? false
                                                          : true
                                                      }
                                                      value={itemT.value}
                                                    >
                                                      {itemT.value}
                                                    </option>
                                                  ) : (
                                                    <option
                                                      key={indexdataT}
                                                      value={itemT.value}
                                                    >
                                                      {itemT.value}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ""}
                                        </Form.Select>
                                      </td>
                                      <td>
                                        <DatePicker
                                          onChange={(date) =>
                                            this.handleDataChangeFromDate(
                                              indexedTd,
                                              date
                                            )
                                          }
                                          selected={iteamTd.AllocationFromDate}
                                          dateFormat="dd-MMM-yyyy"
                                          minDate={iteamTd.MinFromDate}
                                          maxDate={iteamTd.MaxFromDate}
                                          disabled={iteamTd.ModFromDateYN}
                                          className="form-control-data border-remove dateAsealign "
                                          required
                                          placeholderText="From Date *"
                                        />
                                      </td>
                                      <td>
                                        <DatePicker
                                          onChange={(date) =>
                                            this.handleDataChangeToDate(
                                              indexedTd,
                                              date
                                            )
                                          }
                                          selected={iteamTd.AllocationToDate}
                                          dateFormat="dd-MMM-yyyy"
                                          minDate={iteamTd.MinToDate}
                                          maxDate={iteamTd.MaxToDate}
                                          disabled={iteamTd.ModToDateYN}
                                          className="form-control-data border-remove dateAsealign"
                                          required
                                          placeholderText="To Date *"
                                        />
                                        {iteamTd.ErrorDate === true ? (
                                          <span className="tool_tip">
                                            To date must be later than From date
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td className="tdData">
                                        {iteamTd.DeleteYN === true &&
                                        this.state.TotalListCount ===
                                          indexedTd ? (
                                          <span
                                            className="saveBtnUsMin cursor"
                                            onClick={this.handleDataRemoveDetails(
                                              indexedTd
                                            )}
                                          >
                                            <FaMinusCircle />
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={28}></td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="submit"
                          className="btnval btn btn-success font_size"
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}

                  {this.state.customer === "Edit" ? (
                    <form className="pr-5 mb-5 formUser" method="post">
                      <div className="rowUser">
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Name *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="NameEd"
                              onChange={this.handleDataChange}
                              placeholder="Name"
                              className="edit_job form__field"
                              value={this.state.NameEd}
                            />
                          </FloatingLabel>
                        </div>
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Designation *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="DesignationEd"
                              onChange={this.handleDataChange}
                              placeholder="Designation"
                              className="edit_job form__field"
                              value={this.state.DesignationEd}
                            />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Eligibility *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="EligibilityEd"
                              onChange={this.handleDataChange}
                              placeholder="Eligibility"
                              className="edit_job form__field"
                              value={this.state.EligibilityEd}
                            />
                          </FloatingLabel>
                        </div>
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Amount *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="AmountEd"
                              onChange={this.handleDataChange}
                              placeholder="Amount"
                              className="edit_job form__field"
                              value={this.state.AmountEd}
                            />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-12 form-group input-user">
                          <FloatingLabel
                            controlId="floatingInputGrid"
                            className=""
                            label="Remarks *"
                          >
                            <Form.Control
                              type="text"
                              required
                              name="RemarksEd"
                              onChange={this.handleDataChange}
                              placeholder="Remarks"
                              className="edit_job form__field"
                              value={this.state.RemarksEd}
                            />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="submit"
                          onClick={(event) =>
                            this.setState({ submitvalue: "90" })
                          }
                          className="btnval btn btn-success font_size"
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        {this.state.loading === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
